import { execSafeSaga } from '@lib/helpers';
import { all, call, takeEvery, put, select } from 'redux-saga/effects';
import { actionType } from './action';
import { IAction } from '@interface/IAction';
import { HongKongMoment as moment } from '@lib/HongKongMoment';
import {
    getAccountSummary,
    fetchTransactionRecords,
    fetchDepositWithdrawalRecords,
    withdrawal,
    fetchFunderContributions,
    fetchAwaitingRepaymentRecords,
    fetchPastAuctions,
} from './balance-asset.service';
import {
    setAccountBalanceSummary,
    setTransactionRecords,
    setDepositWithdrawalRecords,
    setFunderContributions,
    setAwaitingRepaymentRecords,
    setPastAuctions,
} from './action';

function* getAccountSummarySaga(action: IAction) {
    yield execSafeSaga(function*() {
        const { setIsGettingBalanceSummary } = action.payload;
        const accountSummary = yield call(getAccountSummary);
        setIsGettingBalanceSummary(false);
        yield put(setAccountBalanceSummary(accountSummary));
    });
}

function* fetchTransactionRecordsSaga(action: IAction) {
    const {
        startDate,
        endDate,
        currency,
        setIsFetchingTxnRecords,
    } = action.payload;
    yield execSafeSaga(function*() {
        const txnRecords = yield call(fetchTransactionRecords, {
            startDate,
            endDate,
            currency,
        });
        setIsFetchingTxnRecords(false);
        yield put(setTransactionRecords(txnRecords));
    });
}

function* fetchDepositWithdrawalRecordsSaga(action: IAction) {
    const {
        startDate,
        endDate,
        currency,
        setIsFetchingDepositWithdrawalRecords,
    } = action.payload;
    yield execSafeSaga(function*() {
        const depositWithdrawalRecords = yield call(
            fetchDepositWithdrawalRecords,
            { startDate, endDate, currency },
        );
        setIsFetchingDepositWithdrawalRecords(false);
        yield put(setDepositWithdrawalRecords(depositWithdrawalRecords));
    });
}

function* withdrawalSaga(action: IAction) {
    const {
        withdrawalAmount,
        currency,
        setIsSendingWithdrawalRequest,
        refreshDepositWithdrawalRecords,
    } = action.payload;
    yield execSafeSaga(
        function*() {
            yield call(withdrawal, { withdrawalAmount, currency });
            setIsSendingWithdrawalRequest(false);
            refreshDepositWithdrawalRecords();
        },
        () => setIsSendingWithdrawalRequest(false),
    );
}

function* fetchFunderContributionsSaga(action: IAction) {
    const {
        currencies,
        isRemitted,
        setIsFetchingContributions,
    } = action.payload;
    yield execSafeSaga(function*() {
        const contributions = yield call(fetchFunderContributions, {
            currencies,
            isRemitted,
        });
        setIsFetchingContributions(false);
        yield put(setFunderContributions(contributions));
    });
}

function* fetchAwaitingRepaymentRecordsSaga(action: IAction) {
    const { setIsFetchingAwaitingRecords } = action.payload;
    yield execSafeSaga(function*() {
        const records = yield call(fetchAwaitingRepaymentRecords);
        setIsFetchingAwaitingRecords(false);
        yield put(setAwaitingRepaymentRecords(records));
    });
}

function* fetchPastAuctionsSaga(action: IAction) {
    const { startDate, endDate, setIsFetchingPastRecords } = action.payload;
    yield execSafeSaga(function*() {
        const records = yield call(fetchPastAuctions, { startDate, endDate });
        setIsFetchingPastRecords(false);
        yield put(setPastAuctions(records));
    });
}

function* rootSaga() {
    yield all([
        takeEvery(
            actionType.GET_ACCOUNT_BALANCE_SUMMARY,
            getAccountSummarySaga,
        ),
        takeEvery(
            actionType.FETCH_TRANSCATION_RECORDS,
            fetchTransactionRecordsSaga,
        ),
        takeEvery(
            actionType.FETCH_DEPOSIT_WITHDRAWAL_RECORDS,
            fetchDepositWithdrawalRecordsSaga,
        ),
        takeEvery(actionType.WITHDRAWAL, withdrawalSaga),
        takeEvery(
            actionType.FETCH_FUNDER_CONTRIBUTIONS,
            fetchFunderContributionsSaga,
        ),
        takeEvery(
            actionType.FETCH_AWAITING_REPAYMENT_RECORDS,
            fetchAwaitingRepaymentRecordsSaga,
        ),
        takeEvery(actionType.FETCH_PAST_AUCTIONS, fetchPastAuctionsSaga),
    ]);
}

export default rootSaga;
